import { Component } from 'react';
import PropTypes from 'prop-types';
import Clock from 'scripts/components/Clock';
import Weather from 'scripts/components/Weather';
import moment from 'moment-timezone/moment-timezone';
import { timezone, forecast, useCelsius } from 'scripts/config';
import { startTracking } from 'scripts/utils';
import styles from 'styles/chrome';

export default class Chrome extends Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node
		]).isRequired
	}

	componentWillMount() {
		const timezoneName = timezone.split('|')[0];

		// Add required timezone data into lib
		moment.tz.add(timezone);
		moment.tz.setDefault(timezoneName);

		// Custom ad targeting logic
		if (/(www|us).cnn.com/.test(location.href)) {
			window.CNNI = {
				slotTargets: {
					ad_mod_cd86bba9b: { edition: 'dom' }
				}
			};
		}
	}

	componentDidMount() {
		startTracking(this.refs.chrome, this.props.children.props.display);
	}

	render() {
		return (
			<div ref="chrome" className={styles.wrapper}>
				<div className={styles.panels}>
					<Clock />
					<Weather forecast={forecast} useCelsius={useCelsius} />
				</div>

				<div id="ad_mod_cd86bba9b" />

				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/components/Chrome.es6